export default __webpack_public_path__ + "static/media/cpr7.73a4926b.png";